module.exports = __webpack_public_path__ + "static/autoplay-ffed887276b1e8e27f295a87a7a4ea93.png";